import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type IconName = 'brand' | 'support' | 'globe' | 'shield' | 'arrow' | 'insured' | 'provider' | 'guarantor' | 'manager'
  | 'card' | 'document' | 'bell' | 'refund' | 'alert' | 'user' | 'empty' | 'pill' | 'ban' | 'search' | 'paperclip' | 'close';

@Component({
  selector: 'app-ui-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      @switch (name) {
        @case ('brand') {
          <path d="M12 3.1a8.9 8.9 0 1 0 8.9 8.9A8.9 8.9 0 0 0 12 3.1Z" />
          <path d="M8.1 12h7.8M12 8.1v7.8" />
        }
        @case ('support') {
          <path d="M5.2 13.3v-2.1a6.8 6.8 0 0 1 13.6 0v2.1" />
          <path d="M5.2 12.5H4.1a1.6 1.6 0 0 0-1.6 1.6v2.1a1.6 1.6 0 0 0 1.6 1.6h1.1v-5.3Zm13.6 0h1.1a1.6 1.6 0 0 1 1.6 1.6v2.1a1.6 1.6 0 0 1-1.6 1.6h-1.1v-5.3Z" />
          <path d="M18.8 17.6c-.8 1.8-2.5 2.8-5.2 2.8h-1" />
        }
        @case ('globe') {
          <circle cx="12" cy="12" r="9" />
          <path d="M3.4 9h17.2M3.4 15h17.2M12 3c2.1 2.4 3.2 5.4 3.2 9S14.1 18.6 12 21M12 3C9.9 5.4 8.8 8.4 8.8 12s1.1 6.6 3.2 9" />
        }
        @case ('shield') {
          <path d="M12 2.8 19 5.7v5.2c0 4.6-2.7 8.2-7 10.3-4.3-2.1-7-5.7-7-10.3V5.7L12 2.8Z" />
          <path d="m8.7 12 2.1 2.1 4.6-4.7" />
        }
        @case ('arrow') {
          <path d="M4 12h15M14 7l5 5-5 5" />
        }
        @case ('insured') {
          <circle cx="12" cy="8" r="3.2" /><path d="M5.8 19.5c.5-4 2.6-6.1 6.2-6.1s5.7 2.1 6.2 6.1" /><path d="M17.8 4.8h3.4M19.5 3.1v3.4" />
        }
        @case ('provider') {
          <path d="M4 20V8.5h16V20M8 8.5V4h8v4.5M9 13h6M12 10v6M7 20v-3h10v3" />
        }
        @case ('guarantor') {
          <path d="M12 2.8 19 5.7v5.2c0 4.6-2.7 8.2-7 10.3-4.3-2.1-7-5.7-7-10.3V5.7L12 2.8Z" /><path d="M8.7 12h6.6M12 8.7v6.6" />
        }
        @case ('manager') {
          <rect x="3" y="4" width="18" height="16" rx="1.5" /><path d="M3 9h18M8 4v5M16 4v5M7 13h3M14 13h3M7 17h3M14 17h3" />
        }
        @case ('card') {
          <rect x="2.5" y="5" width="19" height="14" rx="1.5" /><path d="M2.5 9.5h19M6 14.5h5" />
        }
        @case ('document') {
          <path d="M7 2.8h7.2L18 6.6v14.6H7V2.8Z" /><path d="M14 2.8v4h4M9.5 12h5M9.5 15.5h5" />
        }
        @case ('bell') {
          <path d="M6 10.5a6 6 0 0 1 12 0v4.2l1.6 2.6H4.4L6 14.7V10.5Z" /><path d="M9.8 19.8a2.2 2.2 0 0 0 4.4 0" />
        }
        @case ('refund') {
          <circle cx="12" cy="12" r="9" /><path d="M14.6 9.3a2.9 2.9 0 0 0-2.6-1.5c-1.8 0-3 1.3-3 3.2s1.2 3.2 3 3.2a2.9 2.9 0 0 0 2.6-1.5M8.3 10.2h4.4M8.3 13.8h4.4" />
        }
        @case ('alert') {
          <rect x="2.5" y="5" width="19" height="14" rx="1.5" /><path d="M12 9v4" /><circle cx="12" cy="15.6" r=".2" fill="currentColor" />
        }
        @case ('user') {
          <circle cx="12" cy="8.3" r="3.4" /><path d="M5.3 20c.6-4.1 2.8-6.2 6.7-6.2s6.1 2.1 6.7 6.2" />
        }
        @case ('empty') {
          <circle cx="10.3" cy="10.3" r="6.3" /><path d="m19.5 19.5-4.7-4.7M8 10.3h4.6" /><circle cx="17.5" cy="6.2" r="2.2" /><path d="M17.5 5.3v.2M17.5 7v.1" />
        }
        @case ('pill') {
          <rect x="3.5" y="9" width="17" height="6" rx="3" transform="rotate(-20 12 12)" /><path d="m10.4 9.7 3.2 4.6" />
        }
        @case ('ban') {
          <circle cx="12" cy="12" r="9" /><path d="m5.9 5.9 12.2 12.2" />
        }
        @case ('search') {
          <circle cx="10.8" cy="10.8" r="6.8" /><path d="m20 20-4.6-4.6" />
        }
        @case ('paperclip') {
          <path d="M8.5 12.5 15 6a3 3 0 0 1 4.2 4.2l-8 8a5 5 0 0 1-7-7l7.3-7.3" />
        }
        @case ('close') {
          <path d="m5 5 14 14M19 5 5 19" />
        }
      }
    </svg>
  `,
  styles: [`
    :host { display: inline-flex; width: 1.25rem; height: 1.25rem; flex: 0 0 auto; }
    svg { width: 100%; height: 100%; stroke: currentColor; stroke-width: 1.65; stroke-linecap: round; stroke-linejoin: round; }
  `]
})
export class UiIconComponent {
  @Input({ required: true }) name!: IconName;
}
